import React,{createContext, useEffect,useState} from 'react';
import RoutesCommponent from './routes/RoutesCommponent'; 
import Web3 from "web3";
import 'react-toastify/dist/ReactToastify.css'; 
// import NavigationScroll from './NavigationScroll';
import screens from './screens';
import components from './components';
import { ToastContainer } from 'react-toastify';
import contractABI from './utils/contractABI';
import { LangContext } from './utils/contaxt';
import { ApprovalRequestProvider } from './Context/ApprovalRequestContext';
import 'react-image-crop/dist/ReactCrop.css'
// or scss:
import 'react-image-crop/src/ReactCrop.scss'

const App = () => {
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const [isconnected, setisconnected] = useState(false);
  const [signer, setSigner] = useState(null);

  

  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage

      } catch (error) {
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    const initContract = async () => {
      try {
        // const contractABI =[
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "buyDataUnit",
        //     "outputs": [],
        //     "stateMutability": "payable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "string",
        //         "name": "_data",
        //         "type": "string"
        //       },
        //       {
        //         "internalType": "uint256",
        //         "name": "_price",
        //         "type": "uint256"
        //       },
        //       {
        //         "internalType": "string",
        //         "name": "_dataUnitType",
        //         "type": "string"
        //       }
        //     ],
        //     "name": "createDataUnit",
        //     "outputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "string",
        //         "name": "_name",
        //         "type": "string"
        //       }
        //     ],
        //     "name": "registerProvider",
        //     "outputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "stateMutability": "nonpayable",
        //     "type": "constructor"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllDataUnitTypes",
        //     "outputs": [
        //       {
        //         "internalType": "string[]",
        //         "name": "",
        //         "type": "string[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getAllProviders",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "address payable",
        //             "name": "walletAddress",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "balance",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "name",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "bool",
        //             "name": "active",
        //             "type": "bool"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "sales",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.Provider[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "getAvailableDataUnitsById",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit",
        //         "name": "",
        //         "type": "tuple"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getBuyerDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "_dataUnitId",
        //         "type": "uint256"
        //       }
        //     ],
        //     "name": "getDataUnitRevenue",
        //     "outputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "",
        //         "type": "uint256"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [],
        //     "name": "getOwner",
        //     "outputs": [
        //       {
        //         "internalType": "address",
        //         "name": "",
        //         "type": "address"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderDataUnits",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "uint256",
        //             "name": "id",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "data",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "price",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "dataUnitType",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "address payable",
        //             "name": "provider",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "totalRevenue",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "purchaseCount",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.DataUnit[]",
        //         "name": "",
        //         "type": "tuple[]"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderDetails",
        //     "outputs": [
        //       {
        //         "components": [
        //           {
        //             "internalType": "address payable",
        //             "name": "walletAddress",
        //             "type": "address"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "balance",
        //             "type": "uint256"
        //           },
        //           {
        //             "internalType": "string",
        //             "name": "name",
        //             "type": "string"
        //           },
        //           {
        //             "internalType": "bool",
        //             "name": "active",
        //             "type": "bool"
        //           },
        //           {
        //             "internalType": "uint256",
        //             "name": "sales",
        //             "type": "uint256"
        //           }
        //         ],
        //         "internalType": "struct FXDataNetwork.Provider",
        //         "name": "",
        //         "type": "tuple"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   },
        //   {
        //     "inputs": [
        //       {
        //         "internalType": "address",
        //         "name": "_providerAddress",
        //         "type": "address"
        //       }
        //     ],
        //     "name": "getProviderSales",
        //     "outputs": [
        //       {
        //         "internalType": "uint256",
        //         "name": "",
        //         "type": "uint256"
        //       }
        //     ],
        //     "stateMutability": "view",
        //     "type": "function"
        //   }
        // ];
      
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage

      } catch (error) {
        console.log(error);
      }
    };


    if (web3) {
      initContract();
    }
  }, [web3]);
  


  const [lang,setlang]=useState()
  const [first_Name,setfirst_Name]=useState()
  const [Last_Name,setLast_Name]=useState()
  
  


  
  return (
    <>
    <div>
      <ToastContainer/>
    <ApprovalRequestProvider>
    <LangContext.Provider value={{lang,first_Name,Last_Name, setlang,setfirst_Name,setLast_Name}}>
    <RoutesCommponent web3={web3}  initWeb3={initWeb3} contracts={contract} />
    </LangContext.Provider>
    </ApprovalRequestProvider>
      </div>
      </>
  )
}

export default App